import { useRouter } from 'next/router';
import * as React from 'react';

import { EventRegistrationTable } from '@/components/EventRegistrationTable';

import { ConferenceEventTabsLayout } from '../layouts/ConferenceEventTabsLayout';

export const ConferenceRegistrationPage: React.FC = () => {
  const router = useRouter();
  const eventId = router.query.eventId.toString();

  return (
    <ConferenceEventTabsLayout eventId={eventId}>
      <EventRegistrationTable eventId={eventId} />
    </ConferenceEventTabsLayout>
  );
};
